import React, { useEffect, useState } from "react";
import { Switch, Route } from "react-router-dom";
import { Grid } from "@material-ui/core";
import TopBar from "../components/shared/TopBar";
import {
  SystemMessageSnack,
  SystemLoading,
  IntegrationMessageSnack,
} from "../components/UI/System";
import { PageLoading } from "../components/UI/Page";
import LeftBar from "../components/Project/LeftBar";
import Header from "../components/Project/Header";
import Contract from "./Contract";
import Measurement from "./Measurement";
import Discounts from "./Discounts";
import Advances from "./Advances";

import Page404 from "../components/shared/Errors/404";
import { lang } from "../i18nLang";
import { ContractStore } from "store";

type IProps = {
  match: any;
};

const Project = ({ match }: IProps) => {
  const { path } = match;
  const contractId = match.params.id || "";

  const [loading, setLoading] = useState(true);
  const [projectName, setProjectName] = useState("");

  useEffect(() => {
    ContractStore.subscribeContract(
      contractId,
      (contract) => {
        setLoading(false);
        setProjectName(contract?.development.name);
      },
      () => setLoading(false)
    );

    return () => {
      ContractStore.unsubscribeContract();
    };
  }, [contractId]);

  const contract = ContractStore.getCurrentContract();
  const title = contract?.name || "";

  return (
    <>
      <TopBar enableActions={true} variant="primary" title={projectName} />
      <Grid container>
        <LeftBar />

        {loading && <PageLoading />}
        {!loading &&
          (!contract ? (
            <Page404 title={lang("project.contractNotFound")} />
          ) : (
            <Grid
              container
              item
              xs
              direction="column"
              style={{ maxWidth: "calc(100% - 40px)" }}
            >
              <Switch>
                <Route path={`${path}/contract`}>
                  <Contract title={title} />
                </Route>
                <Route
                  path={`${path}/measurement/:id([0-9a-zA-Z]{20})`}
                  children={({ match }) => (
                    <>
                      <Header
                        title={title}
                        type="measurement"
                        showSettings={true}
                      />
                      <Measurement match={match} />
                    </>
                  )}
                />
                <Route path={`${path}/discounts`}>
                  <Header title={title} type="contract" />
                  <Discounts />
                </Route>
                <Route path={`${path}/advances`}>
                  <Header title={title} type="contract" />
                  <Advances />
                </Route>
                <Route>
                  <Page404 />
                </Route>
              </Switch>
            </Grid>
          ))}
      </Grid>
      <SystemLoading />
      <SystemMessageSnack />
      <IntegrationMessageSnack />
    </>
  );
};

export default Project;
